module.exports = __webpack_public_path__ + "static/media/money-graph-with-up-arrow.93dcc0c8.svg";